module.exports = __webpack_public_path__ + "img/Concierge.4fa1c9f3.svg";